import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-card-icon',
  templateUrl: './card-icon.component.html',
  styleUrls: ['./card-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
